import React, { useState } from "react";
import { FaUser } from "react-icons/fa";
import { BsX } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../Redux/Actions/userAction";

const SideBar = ({ sidebarCall, ableClass }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  async function handleLogout() {
    // logout User
    dispatch(logoutUser());
    navigate("/");
  }

  const navigateProfile=()=>{
    navigate('/profile');
  }

  

  return (
    <div>
      <aside
        className={`scrollbar w-80 fixed h-screen overflow-y-scroll top-0 z-10 transition-all duration-500    ${ableClass} `}
        aria-label="Sidebar "
      >
        <div className="  pb-4   bg-gray-800">
          <div className="w-full  px-2 py-3 bg-rose-600">
            <div className="flex w-full relative text-white mb-4">
              <FaUser className=" w-6 h-6 text-xl border  border-white  rounded-full" />
              <h1 className="  text-md ml-4 font-medium">Hello, Sign in</h1>
              <button
                onClick={sidebarCall}
                className=" absolute right-0 -top-1 text-4xl "
              >
                <BsX />
              </button>
            </div>
            <div className="grid grid-cols-2 ">
              <button
                onClick={navigateProfile}
                type="button"
                className="text-white  hover:text-black border hover:bg-white focus:outline-none font-medium rounded-sm text-sm px-5 py-1 text-center mr-2 mb-2 "
              >
                Account
              </button>
              <button
               onClick={navigateProfile}
                type="button"
                className="text-white hover:text-black border hover:bg-white focus:outline-none font-medium rounded-sm text-sm px-5 py-1 text-center mr-2 mb-2 "
              >
                Order
              </button>
            </div>
          </div>
          <ul className="space-y-2 text-white py-2 px-1">
            <li>
              <Link
                to="/home"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg hover:bg-gray-700"
              >
                <span className="ml-1">Home</span>
              </Link>
            </li>
            <li>
              <Link
                to="/shopbycategory"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg hover:bg-gray-700"
              >
                <span className="flex-1 ml-1 whitespace-nowrap">
                  Shop by Category
                </span>
              </Link>
            </li>
            <li>
              <Link
                to="/cart"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg hover:bg-gray-700"
              >
                <span className="flex-1 ml-1 whitespace-nowrap">My List</span>
              </Link>
            </li>
            <li>
              <Link
                to="/wallet"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg hover:bg-gray-700"
              >
                <span className="flex-1 ml-1 whitespace-nowrap">
                  AppnaApp Wallet
                </span>
              </Link>
            </li>
            <li>
              <Link
                to="/gifting"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg hover:bg-gray-700"
              >
                <span className="flex-1 ml-1 whitespace-nowrap">
                  AppnaApp Gift Store
                </span>
              </Link>
            </li>
            <li>
              <Link
                to="/home"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg hover:bg-gray-700"
              >
                <span className="flex-1 ml-1 whitespace-nowrap">
                  AppnaApp Gift Card
                </span>
              </Link>
            </li>
            <li>
              <Link
                to="/alloffers"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg hover:bg-gray-700"
              >
                <span className="flex-1 ml-1 whitespace-nowrap">
                  All offers
                </span>
              </Link>
            </li>
          </ul>
          <ul className="pt-4 mt-4 space-y-2 border-t border-gray-200 text-white">
            <li>
              <Link
                to="/profile"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group"
              >
                <span className="ml-1">My Account</span>
              </Link>
            </li>
            {user && (
              <li>
                <button
                  onClick={handleLogout}
                  className="flex items-center p-2 text-base w-full font-normal rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group"
                >
                  <span className="ml-1">Logout</span>
                </button>
              </li>
            )}
            <li>
              <Link
                to="/help"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg transition duration-75 hover:bg-gray-700 group"
              >
                <span className="ml-1">Need Help</span>
              </Link>
            </li>
            <li>
              <Link
                to="/aboutus"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg transition duration-75 hover:bg-gray-700  group"
              >
                <span className="ml-1">About us</span>
              </Link>
            </li>
            <li>
              <Link
                to="/home"
                onClick={sidebarCall}
                className="flex items-center p-2 text-base font-normal  rounded-lg transition duration-75 hover:bg-gray-700  group"
              >
                <span className="ml-1">Guide</span>
              </Link>
            </li>
          </ul>

          <div className="p-4 mt-4 text-white font-light text-sm border-2 border-transparent border-t-gray-300  ">
            <h1 className="py-1 text-lg font-bold">Contact us</h1>
            <p className="py-1">WhatsApp us : 4985394834</p>
            <p className="py-1">
              Call Us : 1800 890 1222 <br />
              8:00 AM to 8:00 PM, 365 days
            </p>
            <p className="py-2 ">
              Please note that you are accessing the BETA Version of
              www.appnaapp.com
            </p>
            <p>
              Should you encounter any bugs, glitches, lack of functionality,
              delayed deliveries, billing errors or other problems on the beta
              website, please email us on cs@appnaapp.com
            </p>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default SideBar;
